<div [class.collapsed]="collapsed" class="sidebar-wrapper">
  <div class="sidebar-header">
    <button (click)="toggleCollapse()" color="basic" mat-button>
      <mat-icon>{{ collapsed ? 'keyboard_double_arrow_right' : 'keyboard_double_arrow_left' }}</mat-icon>
    </button>
  </div>
  <div class="item-list">
    <ng-content></ng-content>
  </div>
</div>
